const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the admin user reports component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('adminUserReports', ['Application', 'Users', '$q', '$translate', function(Application, Users, $q, $translate) {
  return {
    restrict: 'E',
    scope: {
      manager: '='
    },
    template: require('../../templates/directives/admin-user-reports.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.information = {
        reports: [],
        restrictions: {},
        assigning: false,
        clearQuery: false,
        page: 1,
        per_page: 15,
        allowNext: false,
        nextPage: function() {
          this.page++;
          this.getReports();
        },
        previousPage: function() {
          this.page--;
          this.getReports();
        },
        onQuery: function(query) {
          if (!Object.keys(query).length) {
            self.information.page = 1;
            self.information.getReports();
            return;
          }
          self.information.page = 1;
          self.information.getReports(query);
        },
        refresh: function() {
          self.information.page = 1;
          self.information.getReports();
        },
        getReports: function(query) {
          var fullQuery = {
            manager_email: $scope.manager.email,
            page: self.information.page,
            per_page: self.information.per_page,
            fields: 'first_name,last_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,last_login',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            'linked_teams-populate': 'name',
            'linked_org_level-populate': 'name',
            'linked_grade-populate': 'name'
          };

          if (query) {
            for (var key in query) {
              fullQuery[key] = query[key];
            }
          }

          Users.find(fullQuery).$promise.then(function(users) {
            self.information.reports = users;
            self.information.allowNext = users.length === self.information.per_page ? true : false;
          });
        }
      };

      self.list = {
        individuals: {},
        showRemoval: false,
        userClick: function(user) {
          if (!this.individuals[user._id]) {
            delete this.individuals[user._id];
          }
          if (Object.keys(this.individuals).length) {
            this.showRemoval = true;
          } else {
            this.showRemoval = false;
          }
        },
        remove: function() {
          var promises = [];
          for (var key in this.individuals) {
            if (this.individuals[key]) {
              promises.push(Users.update({subresource: key}, {manager_email: ''}).$promise);
            }
          }
          $q.all(promises).then(function() {
            var total = Object.keys(self.list.individuals).length;
            self.list.individuals = {};
            self.list.showRemoval = false;
            self.information.page = 1;
            self.information.getReports();
            $translate('adminUserReports.removed_users',{ total: total, name: $scope.manager.full_name}).then(function (translation) {
              Application.messaging.addMessage({type: 'success', duration: 5, text: translation});
            })
          }).catch(function(error) {
            // handle error
            console.log('error in updating users: ', error);
          });
        }
      };

      $scope.$watch('manager', function(newVal, oldVal) {
        if (!newVal || !newVal.email) {
          return;
        }
        var oldEmail = oldVal ? oldVal.email : '';
        if (newVal.email !== oldEmail) {
          self.information.restrictions.manager_email = $scope.manager.email;
          self.information.page = 1;
          self.information.getReports();
        }
      }, true);

    }],
    controllerAs: 'reporting'
  };
}]);